import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthStateService } from './auth-state.service';

export interface TabDef {
  name: string;
  iClass: string;
  span?: string;
  routerLink: string;
  matchPrefix: string;
  permission?: number;
}

function masterTabs(): TabDef[] {
  return [
    { name: '企業', iClass: 's-icon-owner', routerLink: '/owner', matchPrefix: '/owner', permission: 10 },
    { name: '商品', iClass: 's-icon-products', routerLink: '/product', matchPrefix: '/product', permission: 10 },
    { name: '消費税率', iClass: 's-icon-tax', routerLink: '/tax-rate', matchPrefix: '/tax-rate', permission: 10 },
    { name: 'ユーザー', iClass: 's-icon-user', routerLink: '/user', matchPrefix: '/user', permission: 10 },
    { name: 'KEYVOX連携', iClass: 'material-symbols-outlined', span: 'room_preferences', routerLink: '/inout-management', matchPrefix: '/inout-management', permission: 10 },
    { name: 'パスワード付与', iClass: 's-icon-passward', routerLink: '/password-reset', matchPrefix: '/password-reset', permission: 10 },
  ];
}

function studioTabs(): TabDef[] {
  return [
    { name: '店舗', iClass: 's-icon-studio', routerLink: '/studio', matchPrefix: '/studio' },
    { name: '従業員', iClass: 's-icon-worker', routerLink: '/staff', matchPrefix: '/staff', permission: 10 },
  ];
}

function studioEditTabs(studioId: string): TabDef[] {
  return [
    { name: '基本情報', iClass: 's-icon-information', routerLink: `/studio/${studioId}/edit`, matchPrefix: `/studio/${studioId}/edit` },
    { name: '清算用情報', iClass: 's-icon-fileChoice', routerLink: `/studio/${studioId}/fee`, matchPrefix: `/studio/${studioId}/fee`, permission: 10 },
    { name: 'ロッカー', iClass: 's-icon-locker', routerLink: `/studio/${studioId}/locker`, matchPrefix: `/studio/${studioId}/locker` },
    { name: '区分コース', iClass: 's-icon-plans', routerLink: `/studio/${studioId}/plan`, matchPrefix: `/studio/${studioId}/plan` },
    { name: '入退館キー', iClass: 's-icon-cardKey', routerLink: `/studio/${studioId}/key`, matchPrefix: `/studio/${studioId}/key` },
  ];
}

function memberTabs(): TabDef[] {
  return [
    { name: '会員情報', iClass: 's-icon-members', routerLink: '/member', matchPrefix: '/member' },
    { name: '諸届申請', iClass: 'fa fa-inbox', routerLink: '/notification', matchPrefix: '/notification' },
    { name: '物販定期便', iClass: 'material-symbols-outlined', span: 'hand_package', routerLink: '/subscription', matchPrefix: '/subscription' },
    { name: '入退館履歴', iClass: 's-icon-history', routerLink: '/inout', matchPrefix: '/inout' },
    { name: '除名者', iClass: 's-icon-exclude', routerLink: '/expelled', matchPrefix: '/expelled' },
  ];
}

function notificationEditTabs(memberId: string): TabDef[] {
  return [
    { name: '区分コース', iClass: 's-icon-plans', routerLink: `/notification/${memberId}/plan`, matchPrefix: `/notification/${memberId}/plan` },
    { name: 'ロッカー', iClass: 's-icon-locker', routerLink: `/notification/${memberId}/locker`, matchPrefix: `/notification/${memberId}/locker` },
    { name: '物販定期便', iClass: 'material-symbols-outlined', span: 'hand_package', routerLink: `/notification/${memberId}/subscription`, matchPrefix: `/notification/${memberId}/subscription` },
    { name: '支払方法', iClass: 's-icon-method', routerLink: `/notification/${memberId}/payment`, matchPrefix: `/notification/${memberId}/payment` },
    { name: '保険適応', iClass: 'material-icons-outlined', span: 'volunteer_activism', routerLink: `/notification/${memberId}/insurance`, matchPrefix: `/notification/${memberId}/insurance` },
    { name: '休会・退会', iClass: 'fa fa-sign-out', routerLink: `/notification/${memberId}/suspend`, matchPrefix: `/notification/${memberId}/suspend` },
    { name: '除名', iClass: 's-icon-exclude', routerLink: `/notification/${memberId}/expel`, matchPrefix: `/notification/${memberId}/expel` },
  ];
}

function settlementTabs(): TabDef[] {
  return [
    { name: '売上管理', iClass: 's-icon-sales', routerLink: '/transaction', matchPrefix: '/transaction' },
    { name: '請求情報', iClass: 's-icon-billingData', routerLink: '/invoice', matchPrefix: '/invoice', permission: 10 },
    { name: '清算情報', iClass: 's-icon-payOff', routerLink: '/balance', matchPrefix: '/balance', permission: 20 },
  ];
}

function aggregationTabs(): TabDef[] {
  return [
    { name: '会員推移', iClass: 'fa fa-bar-chart', routerLink: '/aggregation/membership', matchPrefix: '/aggregation/membership', permission: 30 },
    { name: '会員比率', iClass: 'fa fa-pie-chart', routerLink: '/aggregation/member-ratio', matchPrefix: '/aggregation/member-ratio', permission: 30 },
    { name: 'アンケート', iClass: 's-icon-survey', routerLink: '/aggregation/questionary', matchPrefix: '/aggregation/questionary', permission: 30 },
  ];
}

function marketingTabs(): TabDef[] {
  return [
    { name: '全店', iClass: 's-icon-owner', routerLink: '/marketing/all', matchPrefix: '/marketing/all', permission: 30 },
    { name: '個店', iClass: 's-icon-studio', routerLink: '/marketing/studio', matchPrefix: '/marketing/studio', permission: 30 },
  ];
}

function emailTabs(): TabDef[] {
  return [
    { name: '文面作成', iClass: 'material-icons-outlined', span: 'edit_note', routerLink: '/email/content', matchPrefix: '/email/content', permission: 30 },
    { name: '配信予約', iClass: 'material-icons-outlined', span: 'schedule_send', routerLink: '/email/reservation', matchPrefix: '/email/reservation', permission: 30 },
    { name: '設定', iClass: 'material-icons-outlined', span: 'settings', routerLink: '/email/settings', matchPrefix: '/email/settings', permission: 10 },
  ];
}

function ptReservationTabs(): TabDef[] {
  return [
    { name: '予約一覧', iClass: 'material-icons-outlined', span: 'calendar_today', routerLink: '/pt-reservation', matchPrefix: '/pt-reservation' },
    { name: 'メニュー', iClass: 'material-icons-outlined', span: 'import_contacts', routerLink: '/pt-reservation/menu', matchPrefix: '/pt-reservation/menu' },
    { name: '受付時間', iClass: 'material-icons-outlined', span: 'schedule', routerLink: '/pt-reservation/schedule', matchPrefix: '/pt-reservation/schedule' },
  ];
}

function getTabsForUrl(url: string): TabDef[] {
  const notifMatch = url.match(/^\/notification\/(\d+)\/(plan|locker|payment|insurance|suspend|expel|subscription)(?:\/|$)/);
  if (notifMatch) return notificationEditTabs(notifMatch[1]);

  const studioEditMatch = url.match(/^\/studio\/(\d+)\/(edit|fee|locker|plan|key)/);
  if (studioEditMatch) return studioEditTabs(studioEditMatch[1]);

  if (/^\/(owner|user|product|tax-rate|inout-management|password-reset)\/?$/.test(url)) return masterTabs();
  if (/^\/(studio|staff)\/?$/.test(url)) return studioTabs();
  if (/^\/(member|notification|inout|expelled|subscription)\/?$/.test(url)) return memberTabs();
  if (/^\/(transaction|invoice|balance)\/?$/.test(url)) return settlementTabs();
  if (/^\/aggregation/.test(url)) return aggregationTabs();
  if (/^\/marketing/.test(url)) return marketingTabs();
  if (/^\/email\/(content|reservation|settings)\/?$/.test(url)) return emailTabs();
  if (/^\/pt-reservation/.test(url)) return ptReservationTabs();
  return [];
}

@Injectable({ providedIn: 'root' })
export class ActiveTabsService {
  private router = inject(Router);
  private authState = inject(AuthStateService);

  readonly tabs$: Observable<TabDef[]> = this.router.events.pipe(
    filter(e => e instanceof NavigationEnd),
    startWith(null),
    map(() => {
      const url = this.router.url.split('?')[0];
      const role = this.authState.currentUser?.role ?? 99;
      return getTabsForUrl(url).filter(t => t.permission === undefined || role <= t.permission);
    }),
  );
}
